<mat-toolbar style="padding-right: 60px">
  <mat-icon>done_outline</mat-icon>
  <span>Drag N Drop Todo App</span>
  <span class="spacer"></span>
  <div *ngIf="auth.$authenticated | async" class="right-logout">
    <button mat-icon-button aria-label="logout-icon" (click)="logout()">
      LOGOUT<mat-icon>logout</mat-icon>
    </button>
  </div>
</mat-toolbar>
